var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1973E8",
    d: "M4 15.877v3.125h3.333l9.831-9.217-3.333-3.125L4 15.877ZM19.742 7.37a.794.794 0 0 0 0-1.175l-2.08-1.95a.927.927 0 0 0-1.253 0l-1.627 1.525 3.334 3.125 1.626-1.525Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v15H4z"
  })))));
};
export default SvgEditIcon;